import { render, staticRenderFns } from "./no_legal_lawyer_index.vue?vue&type=template&id=6faa1366&scoped=true"
import script from "./no_legal_lawyer_index.vue?vue&type=script&lang=js"
export * from "./no_legal_lawyer_index.vue?vue&type=script&lang=js"
import style0 from "./no_legal_lawyer_index.vue?vue&type=style&index=0&id=6faa1366&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa1366",
  null
  
)

export default component.exports